/* hs-eslint ignored failing-rules */

import PropTypes from 'prop-types';
import UIListingPage from 'UIComponents/page/UIListingPage';
import Header from './Header';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Page({
  children
}) {
  return /*#__PURE__*/_jsx(UIListingPage, {
    pageLayout: "max-width",
    headerComponent: /*#__PURE__*/_jsx(Header, {}),
    children: children
  });
}
Page.propTypes = {
  children: PropTypes.node
};